export { default as InfoAlert } from './info-alert';
